
import {
    CLEAR_SEARCH_RESULT,
    DO_SEARCH_ACTION_TYPE,
    SET_INITIALIZED
} from '../sagas/search';

const initialState = {
    initialized: false,
    searching: false,
    searchResult: null
};

function search(state = initialState, action) {
    switch (action.type) {
        case CLEAR_SEARCH_RESULT:
            return {
                ...state,
                searchResult: null
            };
        case DO_SEARCH_ACTION_TYPE.LOADING:
            return {
                ...state,
                searchResult: null,
                searching: true
            };
        case DO_SEARCH_ACTION_TYPE.SUCCESS:
            return {
                ...state,
                searchResult: action.searchResult ? action.searchResult : state.searchResult,
                searching: false
            };
        case DO_SEARCH_ACTION_TYPE.FAILED:
            return {
                ...state,
                searchResult: null,
                searching: false
            };
        case SET_INITIALIZED:
            return {
                ...state,
                initialized: action.value
            };
        default:
            return state;
    }
}

export default search;
